module.exports = __webpack_public_path__ + "f53859069207085651d60c21423d812f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cover-photo2.jpg
 ** module id = 740
 ** module chunks = 0
 **/